export default __webpack_public_path__ + "static/media/mobilebackground.1b20c9ee.svg";